(() => {
  const fetchProduct = async (handle) => {
    try { return await (await fetch(`/products/${handle}.js`)).json(); } 
    catch { return null; }
  };

  const findVariant = (product, value) => 
    product?.variants?.find(v => v.options.some(o => o === value));

  const updatePrice = (container, id, variant) => {
    if (!container || !id) return;
    container.setAttribute('data-variant-id', id);
    
    if (variant) {
      const final = container.querySelector('.kaching-product-upsell-item__price-final');
      const old = container.querySelector('.kaching-product-upsell-item__price-old');
      const badge = container.querySelector('.kaching-product-upsell-item__badge');
      
      if (final && variant.price) final.textContent = `$${(variant.price / 100).toFixed(2)}`;
      if (old && variant.compare_at_price) old.textContent = `$${(variant.compare_at_price / 100).toFixed(2)}`;
      if (badge && variant.compare_at_price && variant.price) {
        const save = ((variant.compare_at_price - variant.price) / 100).toFixed(2);
        badge.textContent = `You save $${save}`;
        badge.setAttribute('data-compare-at-price', `$${(variant.compare_at_price / 100).toFixed(2)}`);
      }
    }
    
    setTimeout(() => {
      window.Abra?.render?.();
      setTimeout(() => container.setAttribute('data-variant-id', id), 50);
    }, 100);
  };

  const initItem = async (item) => {
    if (item.dataset.abraInit) return;
    item.dataset.abraInit = '1';
    
    const select = item.querySelector('.kaching-cart-selector');
    const price = item.querySelector('.kaching-product-upsell-item__price-container');
    let handle = price?.getAttribute('data-product-handle');
    
    if (!handle) {
      const link = item.querySelector('.kaching-product-upsell-item__title');
      handle = link?.href?.split('/products/')[1]?.split('?')[0];
    }
    
    if (!select || !price || !handle) return;
    
    const product = await fetchProduct(handle);
    if (!product) return;
    
    const update = () => {
      const variant = findVariant(product, select.value);
      if (variant) updatePrice(price, variant.id, variant);
    };
    
    update();
    select.addEventListener('change', update);
  };

  const initAll = () => document.querySelectorAll('.kaching-cart__carousel-item').forEach(initItem);

  const observe = () => {
    new MutationObserver(mutations => {
      mutations.forEach(m => {
        m.addedNodes.forEach(node => {
          if (node.nodeType === 1) {
            if (node.classList?.contains('kaching-cart__carousel-item')) initItem(node);
            if (node.classList?.contains('kaching-cart__carousel-list') || node.querySelector) {
              (node.querySelectorAll?.('.kaching-cart__carousel-item') || []).forEach(initItem);
            }
          }
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  };

  const init = () => {
    initAll();
    observe();
    [500, 1000, 2000].forEach(t => setTimeout(initAll, t));
  };

  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
})();
